import { get } from "@insite/client-framework/Services/ApiService";
const url = "/api/v1/unionDue";

export function getUnionDueService() {
    return get<any>(url);
}
